import { useEffect, useState, type KeyboardEvent } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "components/common/Modal";
import { Button } from "components/common/Button";
import type { RenameItemModalProps } from "./types";

export const RenameItemModal = ({
  isOpen,
  onClose,
  title,
  placeholder,
  currentName,
  onRename,
  isLoading,
}: RenameItemModalProps) => {
  const { t } = useTranslation();
  const [name, setName] = useState(currentName);

  const isSaveDisabled =
    isLoading || name.trim() === "" || name.trim() === currentName;

  const handleSave = () => {
    if (isSaveDisabled) return;
    onRename(name.trim());
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleSave();
    }
  };

  useEffect(() => {
    if (isOpen) {
      setName(currentName);
    }
  }, [isOpen, currentName]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">{title}</h2>
      <input
        type="text"
        value={name}
        onChange={(event) => setName(event.target.value)}
        onKeyDown={handleKeyDown}
        autoFocus
        className="block w-full py-2 px-3 rounded-md border border-gray-300 bg-white placeholder-gray-500 focus:outline-none focus:border-blue-500 sm:text-sm"
        placeholder={placeholder}
      />
      <div className="flex justify-end gap-3 mt-6">
        <Button size="lg" className="flex-1" onClick={onClose}>
          {t("smartSurveyor.common.cancel")}
        </Button>
        <Button
          variant="primary"
          size="lg"
          className="flex-1"
          onClick={handleSave}
          disabled={isSaveDisabled}
        >
          {t("smartSurveyor.common.save")}
        </Button>
      </div>
    </Modal>
  );
};
